import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
})
export class DynamicFormComponent implements OnInit {

  @Input() input: any; // Input variable to receive data from parent component
  @Input() formGroup: FormGroup; // Form group to bind the dynamic form

  /* ngOnInit */
  ngOnInit() {

  }
}
